export default __webpack_public_path__ + "static/Image-1-5a98f0dfe5285f2053593ab1de7fc8a2.png";